import { useState } from 'react';
import { NJButton, NJIconButton, NJModal, NJModalContentInformation, NJTooltip } from '@engie-group/fluid-design-system-react';
import type { OptimisationSummary } from './types';

export interface ActionsContext {
    canEdit: boolean;
    onClone: (row: OptimisationSummary) => void;
    onDelete: (row: OptimisationSummary) => void;
}

/**
 * Production `OptimisationActionsCellRenderer`: copy only when the user can edit AND the run is finished or failed;
 * delete always visible (the server decides) with a confirmation modal. Launch / stop (legacy CubicWeb runs) are out of scope.
 */
export default function OptimisationActionsCell({ data, context }: { data?: OptimisationSummary; context: ActionsContext }) {
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    if (!data) return null;
    const showClone = context.canEdit && (data.status === 'Succès' || data.status === 'Échec');
    return (
        <>
            <div style={{ display: 'flex', gap: 4, alignItems: 'center', height: '100%' }}>
                {context.canEdit && data.status === 'En Préparation' && (
                    <NJTooltip text="Lancer" hasArrow placement="top">
                        <NJIconButton icon="play_arrow" label="Lancer" variant="primary" scale="xs" />
                    </NJTooltip>
                )}
                {showClone && (
                    <NJTooltip text="Copier cette optimisation" hasArrow placement="top">
                        <NJIconButton icon="content_copy" label="Copier" variant="primary" scale="xs" onClick={() => context.onClone(data)} />
                    </NJTooltip>
                )}
                <NJTooltip text="Supprimer" hasArrow placement="top">
                    <NJIconButton icon="delete_outline" label="Supprimer" variant="primary" scale="xs" onClick={() => setIsDeleteOpen(true)} />
                </NJTooltip>
            </div>
            <NJModal isOpen={isDeleteOpen}>
                <NJModalContentInformation id="delete-optimisation-confirmation" iconVariant="danger" shouldFitViewport title="Confirmation de suppression" centeredFooter={false} onClose={() => setIsDeleteOpen(false)}>
                    <div style={{ marginBottom: 40 }}>
                        <p>Êtes-vous sûr de vouloir supprimer cette optimisation ?</p>
                        <b>{data.name}</b>
                    </div>
                    <NJButton label="Annuler" variant="secondary" style={{ marginRight: 20 }} onClick={() => setIsDeleteOpen(false)} />
                    <NJButton
                        label="Oui, supprimer"
                        style={{ marginLeft: 20 }}
                        onClick={() => {
                            setIsDeleteOpen(false);
                            context.onDelete(data);
                        }}
                    />
                </NJModalContentInformation>
            </NJModal>
        </>
    );
}
